import { ReportingPlayer } from '@frontend/core'

const fallbackLabel = '<Unknown>'

export const getFormattedReportingPlayerLabel = (player: ReportingPlayer) => {
  if (!player.displayName && !player.number) return fallbackLabel

  if (!player.number) return player.displayName

  if (!player.displayName) return `[${player.number}] ${fallbackLabel}`

  return `[${player.number}] ${player.displayName}`
}
